import Center from './Center/index.js';
import Bottom from './Bottom/index.js';
import Right from './Right/index.js';
import useControl from './hooks/useControl.js';

var TiModal = {
  Center: Center,
  Bottom: Bottom,
  Right: Right,
  useControl: useControl
};

export { TiModal };
